import Resource from '@assets/utils/resource';

function toggleOptions($dropdownContainer) {
    const isOpen = $dropdownContainer.hasClass('open');
    $('.custom-options-container').removeClass('open');
    $dropdownContainer.toggleClass('open', !isOpen);
}

function updatePlaceholder($select) {
    const selectedOption = $select.find('option:selected');
    if (!selectedOption.length) return;
    const placeholder = $select
        .parent()
        .find('.select-placeholder');
    placeholder.text(selectedOption.text());
    const stockLabel = selectedOption.attr('data-stock-message-label');
    if (stockLabel) {
        const stockMessage = $('<span>').addClass('stock-message').text(stockLabel);
        placeholder.append(stockMessage);
    }
}

export function createCustomDropdown($select) {
    // Create custom dropdown container
    let $dropdownContainer = $select
        .closest('.custom-select-wrapper')
        .find('.custom-options-container');
    const oldContent = {
        selectHeader: $dropdownContainer.find('.custom-select__header'),
        selectFooter: $dropdownContainer.find('.custom-select__footer'),
        customOptionContainerClass: 'custom-options-container',
    };
    if ($dropdownContainer.length >= 1) {
        $dropdownContainer.remove();
        oldContent.customOptionContainerClass = $dropdownContainer.attr('class');
    }
    $dropdownContainer = $('<div>').addClass(oldContent.customOptionContainerClass);

    $dropdownContainer.append(oldContent.selectHeader);
    // Create custom dropdown options
    $select.find('option').each((index, option) => {
        const $option = $(option);
        const stockLabel = $option.attr('data-stock-message-label');
        const isDisabled = $option.prop('disabled');
        const isResetOption = $option.hasClass('form-control__reset');
        const isSelected = $(option).prop('selected');
        const customOption = $('<div>')
            .addClass('custom-option')
            .toggleClass('reset-option', isResetOption)
            .toggleClass('selected', isSelected)
            .html(`<span>${$(option).text()}</span>`)
            .data({
                disabled: isDisabled,
                selected: isSelected,
                reset: isResetOption,
                value: $option.val(),
            })
            .on('click', (e) => {
                const $target = $(e.currentTarget);
                if ($target.data('disabled') || $target.data('selected')) return;
                e.stopPropagation();
                $select.val($(option).val());
                $(option).attr('selected', 'selected');
                $(e.currentTarget)
                    .addClass('selected')
                    .data('selected', true)
                    .siblings()
                    .removeClass('selected')
                    .data('selected', false);
                $select.trigger('change');
                updatePlaceholder($select);
                $dropdownContainer.removeClass('open');
            });
        if (stockLabel) {
            customOption
                .append(
                    `<span class="stock-message${
                        isDisabled ? ' disabled-overlay' : ''
                    }">${stockLabel}</span>`,
                )
                .toggleClass('disabled', isDisabled);
        } else if (isDisabled) {
            customOption
                .append(
                    `<span class="disabled-overlay">${Resource.msg(
                        'label.outofstock',
                        'common',
                        null,
                    )}</span>`,
                )
                .addClass('disabled');
        }
        $dropdownContainer.append(customOption);
    });
    $dropdownContainer.append(oldContent.selectFooter);
    updatePlaceholder($select);
    $select.parent().append($dropdownContainer);
}

export function customSelectEvents() {
    $(document).on('click', (event) => {
        if ($(event.target).parents('.custom-select-wrapper').length > 0 || $(event.target).hasClass('custom-select-wrapper')) return;
        $('.custom-options-container').removeClass('open');
    });

    $(document).on('click', '.custom-select', (event) => {
        const $currentTarget = $(event.currentTarget);
        if ($(event.target).hasClass('custom-select__header--link') || $(event.target).hasClass('custom-select__header')) return;
        const $dropdownContainer = $currentTarget.find('.custom-options-container');
        toggleOptions($dropdownContainer);
    });
}
